// extracted by mini-css-extract-plugin
module.exports = {"position":"people_position__1OQug","switch":"people_switch__VhDO4"};